<template>
    <div v-if="isreadshow">
        <my-search @search="searchHandler" v-model="pgData" title-placeholder="标段名称/标段编号">
            <el-form-item slot="time">

            </el-form-item>
            <template slot="btn">
                <el-button type="success" icon="el-icon-plus" @click="add()">添加</el-button>
            </template>
        </my-search>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="公告名称" prop="by1" min-width="220"></el-table-column>
            <el-table-column label="公告编码" prop="ggcode" min-width="220"></el-table-column>
            <el-table-column label="公告性质" prop="ggxzname" min-width="80">
                <template slot-scope="scope">
                    <span v-if="scope.row.ggxzcode=='1'||!scope.row.ggxzcode">正常</span>
                    <span v-if="scope.row.ggxzcode=='2'">变更</span>
                </template>
            </el-table-column>
            <el-table-column label="标段名称" prop="bdname" min-width="220"></el-table-column>
            <el-table-column label="中标单位名称" prop="zbdwname" min-width="140"></el-table-column>
            <el-table-column label="中标人代码" prop="zbdwcode" min-width="100"></el-table-column>
            <el-table-column label="中标价格" prop="zbjg" min-width="120">
                <template slot-scope="scope">
                    <div v-if="scope.row.bjlx==='2'||scope.row.bjlx==='3'||scope.row.bjlx==='4'">
                        {{scope.row.zbbj}}                    
                    </div>
                    <div v-else>
                        {{scope.row.zbjg}}元
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="状态" min-width="170">
                <template slot-scope="scope">
                    <my-tag type="warning" v-if="scope.row.shbj==='0'">未提交</my-tag>
                    <my-tag type="primary" v-if="scope.row.shbj==='1'">已提交待内部审核</my-tag>
                    <div v-if="scope.row.shbj==='3'">
                        <my-tag  type="danger">退回：{{scope.row.by5}}</my-tag>
                    </div>
                    <my-tag type="primary" v-if="scope.row.shbj==='4'">监督待审核</my-tag>
                    <template v-if="scope.row.shbj==='5'">
                        <my-tag v-if="scope.row.xtts" type="primary">
                            交易中心待审核
                        </my-tag>
                        <my-tag v-else type="warning">
                            待推送交易中心
                        </my-tag>
                    </template>
                    <div v-if="scope.row.shbj==='6'">
                        <el-button type="text" :loading="loading" @click="getTbzt(scope.row.ggcode)"  icon="el-icon-refresh-right">查看公共服务平台同步结果</el-button>
                    </div>
                    <my-tag type="primary" v-if="scope.row.shbj==='8'">待平台审核</my-tag>
                    <my-tag type="success" v-if="scope.row.shbj==='9'">已发布</my-tag>
                </template>
            </el-table-column>
            <el-table-column label="交易中心" min-width="180">
                <template slot-scope="scope">
                    <jyzx-state :data="scope.row" v-if="scope.row.xtts||scope.row.pushstyle==='1'||scope.row.pushstyle==='2'"></jyzx-state>
                    <el-tag v-if="!scope.row.xtts&&!scope.row.pushstyle">{{scope.row.extstr2}}</el-tag>
                    <push-type 
                        :column="scope.row" 
                        v-if="pgData.isXt==='1'"
                        :pushPage="'zhongbiaogg'" 
                        :primaryKey="scope.row.ggcode"
                        :procode="getQuery('zbprocode')">
                    </push-type>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" min-width="160">
                <template slot-scope="scope">
                    <div v-if="scope.row.shbj==='0'||scope.row.shbj==='3'">
                        <my-btn type="edit" @click="edit(scope.row.ggcode)">编辑</my-btn>
                        <my-btn type="del" @click="del(scope.row.ggcode)">删除</my-btn>
                    </div>
                    <div v-else>
                        <my-btn type="detail" @click="show(scope.row.ggcode,pgData.zbprocode)">查看</my-btn>
                        <el-button type="text" style="margin-left:0px;" icon="el-icon-refresh-left" @click="gettbmt(scope.row.ggcode,'winning')" v-if="scope.row.shbj==='9'&&iszfcg">查看政府采购同步状态</el-button>
                    </div>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('bidUrl')}/revision/DingBiao/ZhongBiaogg/pageListData.json`"></my-pagination>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page';
import JyzxState from '@views/bidding/components/jyzx-state'
import PushType from '@/components-sys/push-type'
export default {
    mixins: [LIST_PAGE_MIXIN],
    components: {
        PushType,JyzxState
    },
    data() {
        return{
            pgData:{
                zbprocode:'',
                sortname : 'addtime',
                isXt:'',              
            },
            isreadshow:true,
            loading:false,
            iszfcg:false,
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        //查看公共服务平台同步结果
        getTbzt:function(ggcode){
            var that=this
            that.loading = true
            $.get(`${this.getGetters('bidUrl')}/manage/business/auditzbjggg/getTbzt.json`,{
                ggcode:ggcode,isXt:this.pgData.isXt,
                t:Math.random(),
            }, (data, res) => {
                that.loading = false
                if(data.code=='v'){
                    if (data.result) {
                        ShowMsgBox(data.msg,'info');
                    } else {
                        ShowMsg("获取信息失败!",'error');
                    }
                }else{
                    ShowMsg(data.msg,'error');
                }
           
                
            }); 
        },
        //查看政府采购同步状态
        gettbmt:function(ggcode,type){
            var that = this;
            that.$get(`${this.getGetters('bidUrl')}/manage/business/AuditZbgg/gettbmt.json`,{ggcode:ggcode,type:type,isXt:this.pgData.isXt}, (data, res) => {
                if(res.code==='v'){
                    if(data.status==='0'){
                        ShowMsg('待推送')
                    }else if(data.status==='1'){
                        ShowMsg('已推送待发布')
                    }else if(data.status==='9'){
                        ShowMsg('已发布','success')
                    }
                }else{
                    ShowMsg(data.msg)
                }
            }); 
        },
        //刷新
        reload:function(){
            var that = this;
            this.isreadshow=false;
            this.$nextTick(function(){
                that.isreadshow=true;
            })
        },
        //删除
        del:function(ggcode){
            var that=this;         
            that.$post(`${this.getGetters('bidUrl')}/revision/DingBiao/ZhongBiaogg/del.json`,{ggcode:ggcode,isXt:this.pgData.isXt}, (data, res) => {
                ShowMsg('删除成功', 'success');
                that.reload();
            }); 
        },
        //详情
        show:function(ggcode){
            this.goto({
                path:'./detail',
                query:{
                    ggcode:ggcode,
                    isXt:this.pgData.isXt
                }
            });
        },
        //添加
        add:function(){
            this.goto({
                path:'./form',
                query:{
                    zbprocode:this.pgData.zbprocode,
                    isXt:this.pgData.isXt
                }
            });
        },
        //修改
        edit:function(ggcode){
            this.goto({
                path:'./form',
                query:{
                    zbprocode:this.pgData.zbprocode,
                    ggcode:ggcode,
                    isXt:this.pgData.isXt
                }
            });
        }
    },
    created() {
        if(this.$route.query.zbprocode!=undefined){
            this.pgData.zbprocode=this.$route.query.zbprocode
        }
        if(this.$route.query.isXt!=undefined){
            this.pgData.isXt=this.$route.query.isXt
        }
    },
    mounted() {
        this.$get(`${this.getGetters('bidUrl')}/revision/DingBiao/ZhongBiaogg/queryListPageData.json`,{
            isXt:this.$route.query.isXt,
            zbprocode:this.$route.query.zbprocode
        }, (data, res) => {
            this.iszfcg = data.iszfcg;
        }); 
    }
}
</script>

<style scoped lang="scss">

</style>
